import { Modal } from "react-bootstrap";
import styles from "./EnquiryModal.module.scss";
import LeadGenForms from "./LeadGenForms";
import { useCallback, useEffect, useState } from "react";
import { useRouter } from "next/router";

const UNIVERSITY_REGEX = /^\/universities\/([^/]+)\/([^/]+)$/;
const CONTACT_US_REGEX = /^\/contact-us\/([^/]+)$/;

interface EnquiryModalProps {
  show: boolean;
  onClose: () => void;
  currentPageUrl: string;
  title?: string;
}

const EnquiryModal = ({
  show,
  onClose,
  currentPageUrl,
  title,
}: EnquiryModalProps) => {
  const [height, setHeight] = useState(400);

  const router = useRouter();

  useEffect(() => {
    if (
      router.asPath &&
      (UNIVERSITY_REGEX.test(router.asPath) ||
        CONTACT_US_REGEX.test(router.asPath))
    ) {
      const element = document.querySelector(".modal-content");
      if (element) {
        element?.classList.add("modal-content-university");
      }
    }
  }, [router.asPath]);

  const handleSetHeight = useCallback((height: number) => {
    setHeight(height);
  }, []);

  return (
    <>
      <Modal
        show={show}
        onHide={onClose}
        centered
        size="lg"
        backdrop={false}
        className={`${styles.modal}`}
      >
        <Modal.Header closeButton className={styles.modalHeader}>
          {title && <Modal.Title>{title}</Modal.Title>}
        </Modal.Header>
        <Modal.Body className={styles.modalBody} style={{ height }}>
          <LeadGenForms url={currentPageUrl} mode="popup" setHeight={handleSetHeight} onClose={onClose}/>
        </Modal.Body>
      </Modal>

      {show && <div className={styles.modalOverlay} />}
    </>
  );
};

export default EnquiryModal;
